export class EstimatedClosingCosts {
  constructor() {
    this.underwritingFee = 500;
    this.processingFee = 450;
    this.discountPoints = 0;
    this.taxServiceFee = 70;
    this.initialPmi = 0;
    this.settlement = 400;
    this.closingFee = 185;
    this.taxCertificate = 0;
    this.closingProtectionLetter = 25;
    this.transferTax = 0;
    this.transferFee = 0;
    this.miscLabel1 = '';
    this.miscValue1 = 0;
    this.miscLabel2 = '';
    this.miscValue2 = 0;
    this.appraisalFee = 650; // heloc / refi default
    this.creditReport = 106; // heloc default
    this.employmentVerification = 158; // heloc default
    this.floodDeterminationFee = 7; // heloc default
    this.lendersTitleInsurance = 100; // heloc default
    this.deedOfTrust = 43; // heloc default
    this.documentPreparationFee = 63; // heloc default
  }
}
